module.exports = __webpack_public_path__ + "img/sort.2869e00a.png";